import {queryIncuBaseInfo} from '@api/incubator/base';
import localDb from '@util/localDb';

// 孵化器基础信息
const INCUBATOR_BASE = 'INCUBATOR_BASE';

export function getIncuBaseInfo(params) {
  return dispatch => {
    return queryIncuBaseInfo(params).then(res => {
      if (res.statusCode === 200) {
        localDb.set(INCUBATOR_BASE, res.data);
        return dispatch({
          type: INCUBATOR_BASE,
          data: res.data,
        });
      }
    });
  };
}

export function incubatorBase(state = {}, action) {
  switch (action.type) {
    case INCUBATOR_BASE:
      return action.data;
    default:
      return localDb.get(INCUBATOR_BASE);
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/incubator/incubator_base.js